import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react'
import { Tooltip, Stepper, Step, StepLabel, useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_StateActions, NavigateContext, M_DrawerTableTextField, M_InputTextField, M_CheckBox, M_Select, M_SimpleTable, M_Button } from 'src/components/M_Components'
import { useDispatch, useSelector } from 'react-redux'
import { useForm, Controller, set } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export default function CreateTransport() {

    const [optionsTransport, setOptionsTransport] = useState([])
    const [optionsInsurance, setOptionsInsurance] = useState([])
    const [dataTransport, setDataTransport] = useState(new Map())
    const [dataDangerClassDriver, setDataDangerClassDriver] = useState([])
    const [dataInsurance, setDataInsurance] = useState([])
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [transportId, setTransportId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [foreignKeyNames, setForeignKeyNames] = useState({})
    const [dataLicenses, setDataLicenses] = useState([])
    const bufferServiceTransport = new BufferService('Transport')
    const bufferServiceInsurances = new BufferService('Insurance')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()
    const [activeStep, setActiveStep] = useState(0)
    const steps = ['InformationTransport', 'Licenses']
    const matches = useMediaQuery("(max-width: 570px)")
    const matchesAlternative = useMediaQuery("(max-width: 1030px)")

    const columnsADR = [
        { Name: 'ADRClassification', NormalizedName: t("DangerClass"), Type: 'select', ForeignTableToPassId: 'ADRClassificationId', ForeignKeyName: 'Description', ForeignTableName: 'ADRClassification' },
        { Name: 'ExpirationDate', NormalizedName: t("ADRExpirationDate"), Type: 'date' }
    ]

    const columnsLicenses = [
        { Name: 'ResourceLicense', NormalizedName: t("ResourceLicense"), Type: 'select', ForeignTableToPassId: 'ResourceLicenseId', ForeignKeyName: 'Name', ForeignTableName: 'ResourceLicense' },
        { Name: 'LicenseNumber', NormalizedName: t("LicenseNumber"), Type: 'string' },
        { Name: 'IssuingAuthority', NormalizedName: t("IssuingAuthority"), Type: 'string' },
        { Name: 'ExpirationDate', NormalizedName: t("ExpirationDate"), Type: 'date' }
    ]

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempOT = M_StateData.filter(obj => obj.key === `optionsTransport`)[0]?.value
            const tempOI = M_StateData.filter(obj => obj.key === `optionsInsurance`)[0]?.value
            const tempDT = M_StateData.filter(obj => obj.key === `dataTransport`)[0]?.value
            const tempDA = M_StateData.filter(obj => obj.key === `dataDangerClassDriver`)[0]?.value
            const tempDI = M_StateData.filter(obj => obj.key === `dataInsurance`)[0]?.value
            const tempTI = M_StateData.filter(obj => obj.key === `transportId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempDL = M_StateData.filter(obj => obj.key === `dataLicenses`)[0]?.value
            if (tempOT || tempOI || tempDT || tempDA || tempDI || tempTI || tempOP || tempDL) {
                setOptionsTransport(tempOT)
                setOptionsInsurance(tempOI)
                const loadedDataTransport = new Map(tempDT)
                setDataTransport(loadedDataTransport)
                setDataDangerClassDriver(tempDA)
                setDataInsurance(tempDI)
                setTransportId(tempTI)
                setOperation(tempOP)
                setDataLicenses(tempDL)
                if (tempOT && tempDT) {
                    const initialForeignKeyNames = {}
                    const fields = Object.fromEntries(loadedDataTransport)

                    tempOT.filter(o => o.Type === 'drawerTable').forEach(elem => {
                        const displayValue = fields[elem.Name]
                        if (displayValue) {
                            initialForeignKeyNames[elem.Name] = displayValue
                        }
                    })
                    setForeignKeyNames(initialForeignKeyNames)
                }

                if (tempDT) {
                    reset(Object.fromEntries(tempDT))
                }
                ctx.setIsLoad(false)
                return
            }
        }
        getTransport()
    }

    const { handleSubmit, control, reset, formState: { errors }, getValues } = useForm({
        defaultValues: Object.fromEntries(dataTransport)
    })

    const saveStateToRedux = useCallback(() => {
        const formValues = getValues()
        const combinedDataForRedux = {
            ...formValues,
            ...foreignKeyNames
        }

        const combinedDataTransportFinal = new Map(dataTransport)
        Object.entries(combinedDataForRedux).forEach(([key, value]) => {
            combinedDataTransportFinal.set(key, value)
        })

        const tempArray = [
            { key: 'optionsTransport', value: optionsTransport },
            { key: 'optionsInsurance', value: optionsInsurance },
            { key: 'dataTransport', value: Array.from(combinedDataTransportFinal) },
            { key: 'dataDangerClassDriver', value: dataDangerClassDriver },
            { key: 'dataInsurance', value: dataInsurance },
            { key: 'transportId', value: transportId },
            { key: 'operation', value: operation },
            { key: 'dataLicenses', value: dataLicenses }
        ]

        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))

    }, [
        id, optionsTransport, optionsInsurance, dataTransport, dataInsurance, dataDangerClassDriver, transportId, operation, dispatch, getValues, foreignKeyNames, dataLicenses
    ])

    useEffect(() => {
        return () => {
            saveStateToRedux()
        }
    }, [id, saveStateToRedux])

    const getTransport = async () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setTransportId(getId)

        let transportOptions = optionsTransport
        let insuranceOptions = optionsInsurance

        if (transportOptions.length === 0) {
            const responseOptions = await bufferServiceTransport.options()

            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }

            transportOptions = responseOptions.filter(option => !option.IsHiddenList)
            setOptionsTransport(transportOptions)
        }

        if (insuranceOptions.length === 0) {
            const response = await bufferServiceInsurances.options()
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', response.response.data.Errors[0], '')
                return
            }

            insuranceOptions = response.filter(option => !option.IsHiddenList && option.Name !== 'Trailer' && option.Name !== 'Transport')
            setOptionsInsurance(insuranceOptions)
        }

        if (getOperation === 'edit' || getOperation === 'view') {
            const valueDataTransport = await bufferServiceTransport.getId(getId)

            if (valueDataTransport.name === 'AxiosError') {
                ctx.toastMessages('error', valueDataTransport.response.data.Errors[0], '')
                ctx2.closeTab(id)
                return
            }

            setDataDangerClassDriver(valueDataTransport.ADRCertificates)
            setDataInsurance(valueDataTransport.Insurances)
            setDataLicenses(valueDataTransport.ResourceLicenses || [])

            const defaultFormValues = {}
            const initialForeignKeyNames = {}
            const newDataTransport = new Map(dataTransport)

            transportOptions.forEach(obj => {
                defaultFormValues[obj.Name] = valueDataTransport[obj.Name]
                newDataTransport.set(obj.Name, valueDataTransport[obj.Name])
                if (obj.IsForeignKey) {
                    const idField = obj.ForeignTableToPassId
                    const labelField = obj.Name
                    defaultFormValues[idField] = valueDataTransport[idField]
                    initialForeignKeyNames[labelField] = valueDataTransport[labelField]
                }
            })

            setDataTransport(newDataTransport)
            setForeignKeyNames(initialForeignKeyNames)
            reset(defaultFormValues)
        }
        ctx.setIsLoad(false)
    }

    const onError = (errors) => {
        const errorKeys = Object.keys(errors)

        if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0]

            const failedField = optionsTransport.find(elem =>
                elem.Name === firstErrorKey ||
                (elem.IsForeignKey && elem.ForeignTableToPassId === firstErrorKey)
            )

            let fieldName = t("RequiredFieldsErrorTitle")

            if (failedField) {
                fieldName = failedField.NormalizedName
            } else {
                fieldName = firstErrorKey
            }

            ctx.toastMessages('error', fieldName, t("RequiredField"))
        }
    }

    const submitTransport = (data) => {
        ctx.setIsLoad(true)

        const finalData = {
            ...data,
            ADRCertificates: dataDangerClassDriver,
            Insurances: dataInsurance,
            ResourceLicenses: dataLicenses
        }
        console.log("aqui o que envia", finalData)

        if (operation === 'edit') {
            bufferServiceTransport.update(transportId, finalData).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", "", response.response.data.Errors[0])
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceTransport.post(finalData).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", "", response.response.data.Errors[0])
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    const createStructureADR = (value, field, index, table) => {
        if (table === 'ADR') {
            setDataDangerClassDriver(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'Licenses') {
            setDataLicenses(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        } else if (table === 'Insurance') {
            setDataInsurance(line => line.map(prev => {
                if (prev.Id == index) {
                    return { ...prev, [field]: value }
                } return prev
            }))
        }
    }


    const headerTableADR = columnsADR.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'ADR')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'ADR')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'ADR')
                                    createStructureADR('', value.ForeignTableToPassId, line.Id, 'ADR')
                                }
                            }}
                            disabled={operation === 'view' || value.disable}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'ADR')}
                            disabled={operation === 'view' || value.disable}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'ADR')}
                            disabled={operation === 'view' || value.disable}
                        />
                    )
                }
            }
        }
    })

    const headerTableInsurances = optionsInsurance.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Name === 'Type' || value.Name === 'Coverage') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Insurance')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'Insurance')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'Insurance')
                                    createStructureADR('', value.ForeignTableToPassId, line.Id, 'Insurance')
                                }
                            }}
                            disabled={operation === 'view' || value.disable}
                            valueField={value.ForeignTableToPassId}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Insurance')}
                            disabled={operation === 'view' || value.disable}
                        />
                    )
                } else if (value.Type === 'decimal') {
                    return (
                        <M_InputTextField
                            type="number"
                            value={line[value.Name] || ""}
                            onChange={(e) => {
                                const newValue = e.target.value === "" ? 0 : e.target.value
                                createStructureADR(newValue, value.Name, line.Id, 'Insurance')
                            }}
                            disabled={operation === 'view' || value.disable}
                        />
                    )
                } else if (value.Type === 'datetime') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Insurance')}
                            disabled={operation === 'view' || value.disable}
                        />
                    )
                }
            }
        }
    })

    const headerLicenses = useMemo(() => columnsLicenses.map((value, index) => {
        return {
            Id: index + 1,
            header: value.NormalizedName,
            field: value.Name,
            body: (line) => {
                if (value.Type === 'select') {
                    return (
                        <M_DrawerTableTextField
                            tableLabel={value.NormalizedName}
                            required={value.Required}
                            entity={value.ForeignTableName}
                            value={line[value.ForeignTableToPassId] && {
                                [value.ForeignTableToPassId]: line[value.ForeignTableToPassId],
                                [value.ForeignKeyName]: line[value.Name]
                            } || null}
                            filterField={value.ForeignKeyName}
                            labelFields={[value.ForeignKeyName]}
                            onSubmitValue={obj => {
                                if (obj) {
                                    createStructureADR(obj[value.ForeignKeyName] || '', value.Name, line.Id, 'Licenses')
                                    createStructureADR(obj[value.ForeignTableToPassId] || '', value.ForeignTableToPassId, line.Id, 'Licenses')
                                } else {
                                    createStructureADR('', value.Name, line.Id, 'Licenses')
                                    createStructureADR('', value.ForeignTableToPassId, 'Licenses')
                                }
                            }}
                            disabled={operation === 'view' ? true : false}
                            valueField={value.ForeignTableToPassId}
                            FILTER={'AllowedForTransport eq true'}
                        />
                    )
                } else if (value.Type === 'date') {
                    return (
                        <M_InputTextField
                            type="date"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Licenses')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                } else if (value.Type === 'string') {
                    return (
                        <M_InputTextField
                            type="text"
                            value={line[value.Name] || ''}
                            onChange={(e) => createStructureADR(e.target.value, value.Name, line.Id, 'Licenses')}
                            disabled={operation === 'view' ? true : false}
                        />
                    )
                }
            }
        }
    }), [columnsLicenses, createStructureADR, t])

    const addDangerClass = () => {
        setDataDangerClassDriver([...dataDangerClassDriver, { Id: dataDangerClassDriver?.length && dataDangerClassDriver[dataDangerClassDriver.length - 1]?.Id + 1 || 0 }])
    }

    const addLicenses = () => {
        setDataLicenses([...dataLicenses, { Id: dataLicenses?.length && dataLicenses[dataLicenses.length - 1]?.Id + 1 || 0 }])
    }

    const AddInsurance = () => {
        setDataInsurance([...dataInsurance, { Id: dataInsurance?.length && dataInsurance[dataInsurance.length - 1]?.Id + 1 || 0 }])
    }

    const deleteADR = (Id) => {
        setDataDangerClassDriver(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }

    const deleteLicenses = useCallback((Id) => {
        setDataLicenses(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }, [ctx, t])

    const deleteInsurance = (Id) => {
        setDataInsurance(prev => prev.filter(obj => obj.Id !== Id))
        ctx.toastMessages('success', '', t("DeleteLine"))
    }

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1)
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (<div className='divFormDriver'>
                    <div className='divDisplayFormDriver'>
                        {optionsTransport.map((elem) => (
                            <div key={elem.Name}>
                                {elem.Type === 'string' ? (
                                    elem.IsForeignKey ? (
                                        <Controller
                                            name={elem.ForeignTableToPassId}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field: { onChange, value } }) => (
                                                <M_DrawerTableTextField
                                                    tableLabel={elem.NormalizedName}
                                                    label={elem.NormalizedName}
                                                    required={elem.Required}
                                                    entity={elem.ForeignTableName}
                                                    value={value ?
                                                        {
                                                            [elem.ForeignTableToPassId]: value,
                                                            [elem.ForeignKeyName]: foreignKeyNames[elem.Name] || dataTransport.get(elem.Name)
                                                        } : null}
                                                    filterField={elem.ForeignKeyName}
                                                    labelFields={[elem.ForeignKeyName]}
                                                    onSubmitValue={obj => {
                                                        if (obj) {
                                                            onChange(obj[elem.ForeignTableToPassId])
                                                            setForeignKeyNames(prev => ({
                                                                ...prev,
                                                                [elem.Name]: obj[elem.ForeignKeyName]
                                                            }))
                                                        } else {
                                                            onChange(null)
                                                            setForeignKeyNames(prev => ({
                                                                ...prev,
                                                                [elem.Name]: null
                                                            }))
                                                        }
                                                    }}
                                                    disabled={operation === 'view' || elem.disable}
                                                    valueField={elem.ForeignTableToPassId}
                                                    error={!!errors[elem.ForeignTableToPassId]}
                                                    helperText={errors[elem.ForeignTableToPassId] ? t("RequiredField") : ""}
                                                />
                                            )}
                                        />
                                    ) : (
                                        <Controller
                                            name={elem.Name}
                                            control={control}
                                            rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                            render={({ field }) => (
                                                < M_InputTextField
                                                    {...field}
                                                    type={"text"}
                                                    label={elem.NormalizedName}
                                                    secondColor={"var(--color-red-dark)"}
                                                    required={elem.IsRequired}
                                                    error={!!errors[elem.Name]}
                                                    helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                    disabled={operation === 'view' || elem.disable}
                                                />
                                            )}
                                        />
                                    )
                                ) : elem.Type === 'int32' || elem.Type === 'uint32' || elem.Type === 'decimal' ? (
                                    <Controller
                                        name={elem.Name}
                                        control={control}
                                        rules={{
                                            required: elem.IsRequired ? t("RequiredField") : false,
                                        }}
                                        render={({ field: { onChange, value, ...field } }) => (
                                            <M_InputTextField
                                                {...field}
                                                type={"text"}
                                                label={elem.NormalizedName}
                                                secondColor={"var(--color-red-dark)"}
                                                required={elem.IsRequired}
                                                onChange={(e) => {
                                                    let inputValue = e.target.value
                                                    if (/^[0-9,]*$/.test(inputValue) || inputValue === "") {
                                                        const cleanValue = inputValue.replace(",", ".")
                                                        onChange(cleanValue)
                                                    }
                                                }}
                                                value={value?.toString().replace(".", ",") || ""}
                                                error={!!errors[elem.Name]}
                                                helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                disabled={operation === 'view' || elem.disable}
                                            />
                                        )}
                                    />
                                ) : elem.Type === 'datetime' ? (
                                    <Controller
                                        name={elem.Name}
                                        control={control}
                                        rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                        render={({ field }) => (
                                            <M_InputTextField
                                                {...field}
                                                type={"date"}
                                                label={elem.NormalizedName}
                                                secondColor={"var(--color-red-dark)"}
                                                required={elem.IsRequired}
                                                error={!!errors[elem.Name]}
                                                helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                disabled={operation === 'view' || elem.disable}
                                            />
                                        )}
                                    />
                                ) : elem.Type === 'boolean' ? (
                                    <Controller
                                        name={elem.Name}
                                        control={control}
                                        render={({ field: { onChange, value, ...field } }) => (
                                            <M_CheckBox
                                                {...field}
                                                label={elem.NormalizedName}
                                                onChange={(e) => onChange(e.target.checked)}
                                                checked={!!value}
                                                disabled={operation === 'view' || elem.disable}
                                            />
                                        )}
                                    />
                                ) : elem.Name === 'FirstBedType' || elem.Name === 'SecondBedType' || elem.Name === 'SuspensionType' || elem.Name === 'BrakeType' ||
                                    elem.Name === 'State' || elem.Name === 'AxleType' || elem.Name === "FrontSuspensionType" || elem.Name === "RearSuspensionType" ||
                                    elem.Name === "DiscTileType" || elem.Name === "RouteType" || elem.Name === "MaintenanceType" || elem.Name === "Gearbox" ? (
                                    <Controller
                                        name={elem.Name}
                                        control={control}
                                        rules={{ required: elem.IsRequired ? t("RequiredField") : false }}
                                        defaultValue={elem.EnumValues?.[0]?.Value ?? ""}
                                        render={({ field }) => (
                                            <M_Select
                                                {...field}
                                                noNone
                                                label={elem.NormalizedName}
                                                options={elem.EnumValues?.map(elem => ({
                                                    label: elem.Label,
                                                    value: elem.Value
                                                })) || []}
                                                required={elem.IsRequired}
                                                error={!!errors[elem.Name]}
                                                helperText={errors[elem.Name] ? t("RequiredField") : ""}
                                                disabled={operation === 'view' || elem.disable}
                                            />
                                        )}
                                    />
                                ) : null}
                            </div>
                        ))}
                    </div>
                </div>)
            case 1:
                return (
                    <>
                        <div className='divTableADRCapacity'>
                            {/* tabela do ADR */}
                            <div className='divTableADRandCapacity'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='divLabelName'>
                                        <img src="/icons/svgsDaNet/radioactive.svg" alt="icon" className='iconTablesCreateTrailer' />
                                        {t("DangerClass")}
                                    </div>
                                    <div>
                                        <M_Button
                                            label={t("AddADR")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addDangerClass}
                                            disabled={operation === 'view' || false}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <M_SimpleTable
                                        columns={[
                                            ...headerTableADR,
                                            {
                                                body: (line) => {
                                                    return (
                                                        <div>
                                                            <img src="/icons/svgsDaNet/trash-2.svg"
                                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                                alt="Delete" className='iconDeleteAddress' onClick={() => deleteADR(line.Id)}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            }
                                        ]}
                                        rows={dataDangerClassDriver}
                                    />
                                </div>
                            </div>

                            {/* tabela das licenças */}
                            <div className='divTableADRandCapacity'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className='divLabelName'>
                                        <img src="/icons/svgsDaNet/license.svg" alt="icon" className='iconTablesCreateTrailer' />
                                        {t("Licenses")}</div>
                                    <div>
                                        <M_Button
                                            label={t("addLicense")}
                                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                                alt="save" />
                                            }
                                            borderColor={'var(--color-grey)'}
                                            onClick={addLicenses}
                                            disabled={operation === 'view' || false}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <M_SimpleTable
                                        columns={[
                                            ...headerLicenses,
                                            {
                                                body: (line) => {
                                                    return (
                                                        <div>
                                                            <img src="/icons/svgsDaNet/trash-2.svg"
                                                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                                alt="Delete" className='iconDeleteAddress' onClick={() => deleteLicenses(line.Id)}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            }
                                        ]}
                                        rows={dataLicenses}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* tabela dos Seguros */}
                        <div className='divTableADRandCapacity'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className='divLabelName'>
                                    <img src="/icons/svgsDaNet/shield.svg" alt="icon" className='iconTablesCreateTrailer' />
                                    {t("Insurances")}
                                </div>
                                <div>
                                    <M_Button
                                        label={t("AddInsurance")}
                                        icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                            alt="save" />
                                        }
                                        borderColor={'var(--color-grey)'}
                                        onClick={AddInsurance}
                                        disabled={operation === 'view' || false}
                                    />
                                </div>
                            </div>
                            <div>
                                <M_SimpleTable
                                    columns={[
                                        ...headerTableInsurances,
                                        {
                                            body: (line) => {
                                                return (
                                                    <div>
                                                        <img src="/icons/svgsDaNet/trash-2.svg"
                                                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                                            alt="Delete" className='iconDeleteAddress' onClick={() => deleteInsurance(line.Id)}
                                                        />
                                                    </div>
                                                )
                                            }
                                        }
                                    ]}
                                    rows={dataInsurance}
                                />
                            </div>
                        </div>
                    </>
                )
            default:
                return <div>Formulário Finalizado</div>
        }
    }

    return (
        <div className='divFormTable'>
            <div className="displayMenuActions">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    {operation !== 'view' &&
                        <Tooltip title={t("Save")}>
                            <div className='iconsHeaderTable' onClick={handleSubmit(submitTransport, onError)}>
                                <i className="pi pi-save iconTable"></i>
                                <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                            </div>
                        </Tooltip>
                    }
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divPrincipalAlignFormDriver'>
                <div className='divPrincoipalTitleOrderServiceinTabs'>
                    <div className='titleTab'>
                        <img
                            src={activeStep === 0 ? "/icons/svgsDaNet/trailer.svg" :
                                activeStep === 1 ? "/icons/svgsDaNet/radioactive.svg" :
                                    "/icons/svgsDaNet/crane.svg"
                            }
                            alt='icon'
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                        />
                        {t(steps[activeStep])}
                    </div>
                </div>
                <Stepper
                    alternativeLabel={matchesAlternative && !matches}
                    orientation={matches ? "vertical" : "horizontal"}
                    activeStep={activeStep}
                    sx={{
                        '& .MuiStep-root': {
                            '& .Mui-completed .MuiStepIcon-root': {
                                color: 'var(--color-red-dark)',
                            },
                            '& .Mui-completed .MuiStepConnector-line': {
                                borderColor: 'var(--color-red-dark)',
                            },
                            '& .MuiStepIcon-root.Mui-active': {
                                color: 'var(--color-red-light)'
                            }
                        },
                    }}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel><b>{t(label)}</b></StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div>
                    <div className='divButtonsBackNext'>
                        <div className='divButtonBack'>
                            <M_Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                label={t("Back")}
                                icon={<i className="pi pi-arrow-left iconTable"></i>}
                                borderColor={'var(--color-grey)'}
                            />
                        </div>
                        <div className='divButtonNext'>
                            <M_Button
                                onClick={handleNext}
                                disabled={activeStep === steps.length - 1}
                                label={t("Next")}
                                icon={<i className="pi pi-arrow-right iconTable"></i>}
                                borderColor={'var(--color-grey)'}
                                iconPosition={'right'}
                            />
                        </div>
                    </div>
                    {getStepContent(activeStep)}
                </div>
            </div>
        </div>
    )
}